/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Org_Contract_Activated_SuccessInputs */



/**
* | output |
* | --- |
* | "Contract approved — the organization is active now and its administrator has been emailed." |
*
* @param {Partner_Org_Contract_Activated_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_contract_activated_success = /** @type {((inputs?: Partner_Org_Contract_Activated_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Contract_Activated_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Vertrag freigegeben — die Organisation ist jetzt aktiv und die Administration wurde per E-Mail informiert.")
	return /** @type {LocalizedString} */ ("Contract approved — the organization is active now and its administrator has been emailed.")
});